/*
 * Handles the counter for the number of selected items
 */
/*globals saveAs */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "filesaver",
  "modules/shared/sortableList/downloadUtilities/sortableListDownloadUtilities",
  "modules/shared/sortableList/sortableListTitle/sortableListTitleView",
], function (Marionette, Backbone, Messenger, FileSaver, DownloadUtilities, SortableListTitleView) {
  var SortableListTitleController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "sortableListTitle";
      this.region = options.region;
      this.title = options.title;
      this.headers = options.headers;
      this.hideHider = options.hideHeader;
      this.downloadable = options.downloadable;
      this.downloadID = options.downloadID;
      this.downloadBatch = false;
      this.csvData = "";
      this._setUpVents();
    },
    show: function (collection) {
      var _this = this;
      this.collection = collection;
      // If the collection is over 1000, then set to batch mode
      if (this.collection.isSynced && this.collection.length > 1000) {
        this.downloadBatch = true;
      }
      this.collection.once(
        "sync",
        function () {
          if (this.collection.length > 1000) {
            this.downloadBatch = true;
          }
        },
        this,
      );

      var model = new Backbone.Model();
      model.set("title", this.title);
      model.set("hideHeader", this.hideHider);
      model.set("downloadable", this.downloadable);
      model.set("downloadID", this.downloadID);

      // Check if any of the headers are hideable/filterable
      // If none are found, then the export dropdown doesn't need to include exporting filtered data
      var canFilter = this._checkHeadersForFilter(this.headers);
      model.set("canFilter", canFilter);
      this.view = new SortableListTitleView.sortableListTitleView({ model: model });

      this.view.on(
        "download:all:csv",
        function () {
          this.view.hideDownloadMenu(this.downloadID);
          if (this.downloadBatch) {
            Messenger.vent.trigger("show:download:display");
          }
          window.setTimeout(function () {
            _this._downloadTableCsv(false);
          }, 250);
        },
        this,
      );

      this.view.on(
        "download:all:xlsx",
        function () {
          this.view.hideDownloadMenu(this.downloadID);
          Messenger.vent.trigger("show:download:display");
          window.setTimeout(function () {
            _this._downloadTableXlsx(false);
          }, 250);
        },
        this,
      );

      this.view.on(
        "download:filtered:csv",
        function () {
          this.view.hideDownloadMenu(this.downloadID);
          if (this.downloadBatch) {
            Messenger.vent.trigger("show:download:display");
          }
          window.setTimeout(function () {
            _this._downloadTableCsv(true);
          }, 250);
        },
        this,
      );
      this.showRegion(this.view);
    },
    _checkHeadersForFilter: function (headers) {
      var canFilter = false;
      if (headers) {
        headers = headers.filter(function (header) {
          return header.get("hideable") === true || header.get("filterable") === true;
        });
        if (headers.length > 0) {
          canFilter = true;
        }
      }
      return canFilter;
    },
    _downloadTableCsv: function (isFiltered) {
      this.csvData = "";
      var filename = DownloadUtilities.getFilename(this.downloadID, this.title);
      // For larger collections, fetch the parsed data in batches of 1000
      if (this.downloadBatch) {
        // Set the indices for the first and last record to get the first batch
        var firstRecord = 0;
        var lastRecord = 999;
        this._getBatchCSVData(firstRecord, lastRecord, isFiltered, filename);
      } else {
        this.csvData = DownloadUtilities.parseDataAsCSV(
          this.downloadID,
          this.collection,
          this.headers,
          0,
          this.collection.length - 1,
          isFiltered,
        );
        this._saveFile(filename);
      }
    },
    _downloadTableXlsx: function () {
      var filename = DownloadUtilities.getFilename(this.downloadID, this.title) + ".xlsx";
      DownloadUtilities.downloadXlsx(this.downloadID, filename, this.collection, this.headers)
        .then(function (xlsxBlob) {
          Messenger.vent.trigger("close:download:display");
          saveAs(xlsxBlob, filename);
        })
        .catch(function (error) {
          Messenger.vent.trigger("close:download:display");
          Messenger.showErrorFromResponse(error);
        });
    },
    _getBatchCSVData: function (firstRecord, lastRecord, isFiltered, filename) {
      var _this = this;
      this.csvData += DownloadUtilities.parseDataAsCSV(
        this.downloadID,
        this.collection,
        this.headers,
        firstRecord,
        lastRecord,
        isFiltered,
      );
      // We reached the final batch when lastRecord is set to the final record of the collection, so save the file
      if (lastRecord === this.collection.length - 1) {
        this._saveFile(filename);
      } else {
        firstRecord += 1000;
        lastRecord += 1000;
        // If lastRecord goes beyond the length of the collection, then set it to the final record for the last batch
        if (lastRecord > this.collection.length - 1) {
          lastRecord = this.collection.length - 1;
        }
        // Send percent complete to the progress bar
        var percentComplete = Math.floor(((lastRecord + 1) / this.collection.length) * 100);
        Messenger.vent.trigger("update:progress:bar", percentComplete);
        window.setTimeout(function () {
          _this._getBatchCSVData(firstRecord, lastRecord, isFiltered, filename);
        }, 1);
      }
    },
    _saveFile: function (filename) {
      if (this.downloadBatch) {
        Messenger.vent.trigger("close:download:display");
      }
      var blob = new Blob([this.csvData], { type: "text/plain;charset=utf-8" });
      saveAs(blob, filename + ".csv");
    },
    _setUpVents: function () {
      //no vents
    },
  });

  return SortableListTitleController;
});
